import React, { useState, Fragment } from "react";
import {
  MdNotifications,
  // MdNotificationsNone,
  MdWbSunny,
} from "react-icons/md";
// import {IoNotifications} from 'react-icons/io'
import { Popover, Transition } from "@headlessui/react";
import { BsFillMoonStarsFill } from "react-icons/bs";
import { FaBars } from "react-icons/fa";
import { useHomeContext } from "../context/HomeContext";
import { useAuth } from "../context/auth";
import { useNavigate } from "react-router-dom";
import { BiLogOut } from "react-icons/bi";
import { FaUserCog } from "react-icons/fa";
import { Menu, MenuItem, MenuButton, MenuDivider } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { ThreeDots } from "react-loader-spinner";
import { useThemeContext } from "../context/ThemeContext";

const Navbar = () => {
  const navigate = useNavigate();
  const { isOpen, isSmallScreen, handleNav, toogleActiveMenu,readNotificationId,
    readAllNotificationId } =
    useHomeContext();
  const { currentMode, setMode } = useThemeContext();
  const { user, logout, token } = useAuth();
  const [notificationData, setNotificationData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const unReadNotifications = useQuery(
    ["notificationDataApi", readNotificationId, readAllNotificationId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}notification/admin/unread/${user._id}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {
        setNotificationData(res?.data);
      },
    }
  );

  //all notification
  const allNotifications = useQuery(
    ["allnotificationDataApi", isLoading],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}notification/admin/${user._id}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {},
    }
  );
  console.log(allNotifications?.data?.data?.data);

  return (
    <>
      <div className="p-3 flex items-center justify-between bg-main-bg  dark:bg-secondary-dark-bg px-3 md:px-10">
        <div className="flex items-center space-x-2 ">
          {!isOpen && (
            <FaBars
              size={30}
              className="dark:text-white text-dark-gray cursor-pointer"
              onClick={isSmallScreen ? toogleActiveMenu : handleNav}
            />
          )}
          {/* <h1 className="font-bold text-3xl text-slate-900 dark:text-white">
            Real Home
          </h1> */}
        </div>
        <div className="flex items-center space-x-4 xl:space-x-6">
          <div>
            {currentMode === "Light" ? (
              <BsFillMoonStarsFill
                size={20}
                className="cursor-pointer text-dark-gray dark:text-white"
                onClick={() => setMode("Dark")}
              />
            ) : (
              <MdWbSunny
                size={20}
                className="cursor-pointer text-dark-gray dark:text-white"
                onClick={() => setMode("Light")}
              />
            )}
          </div>
          <div
            className="relative cursor-pointer "
            onClick={() => navigate("/notification")}
          >
            <MdNotifications
              size={25}
              className="text-dark-gray dark:text-white"
            />
            {unReadNotifications?.data?.data?.count > 0 && (
              <span
                className="absolute -top-2 -right-1 text-[13px] font-medium border-2 border-[#edf2f6] dark:border-[#111114]
             text-white w-[20px] h-[20px] rounded-full bg-red-500 
             flex items-center justify-center text-center"
              >
                {unReadNotifications?.data?.data?.count}
              </span>
            )}
          </div>
          <Menu
            arrow
            menuButton={
              <MenuButton>
                <div className="flex items-start space-x-2">
                  {!isSmallScreen && (
                    <div className="flex flex-col items-start space-x-0">
                      <h1 className="font-medium text-dark-gray dark:text-white text-sm">
                        {user?.firstName + " " + user?.lastName}
                      </h1>
                      <p className="font-light text-[13px] text-dark-gray dark:text-white">
                        {user?.phone}
                      </p>
                    </div>
                  )}
                  <img
                    src={user?.profile}
                    alt=""
                    className="h-10 w-10 rounded-full object-cover"
                  />
                </div>
              </MenuButton>
            }
          >
            <MenuItem onClick={() => navigate("/profile")}>
              <div className="flex items-center space-x-2">
                <FaUserCog className="text-main-color" />
                <h1 className="text-dark-gray font-medium">Profile</h1>
              </div>
            </MenuItem>
            <MenuDivider />
            <MenuItem onClick={logout}>
              <div className="flex items-center space-x-2">
                <BiLogOut className="text-main-color" />
                <h1 className="text-dark-gray font-medium">Logout</h1>
              </div>
            </MenuItem>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default Navbar;
